/**
 * @documental
 * @export Bold
 * @type
 * typographyComponent
 * @use
 * The `Bold` component should be used to identify text content which is important, serious or urgent.
 * @element
 * strong
 * @className
 * bold
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { createComponentStyleHook } from "../../tokens";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import tokenStyles from "./styles.module.css";

/**
 * The Bold component properties.
 */

export interface BoldProps extends BaseProps {}

const useResolvedBoldStyles = createComponentStyleHook<BoldProps>({
  legacyStyles: () => import("./styles.module.scss"),
  tokenStyles,
  componentTokens: "bold",
});

/**
 * Specifies that text content should be displayed as bold. Can be overridden
 * through the use of the [Regular](../Regular/README.md) and [Semibold](../Semibold/README.md)
 * components.
 */
export const Bold: FC<PropsWithChildren<BoldProps>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedBoldStyles(props);
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Bold, "bold"] });

  return (
    <StyleModeBoundary mode={mode}>
      <strong {...baseHtmlProps}>{children}</strong>
    </StyleModeBoundary>
  );
};
